import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Input from '@material-ui/core/Input';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  textFieldContainer: {
    position: 'relative',
    display: 'inline-flex',
    margin: '8px 4px',
  },
  textFieldValue: {
    fontSize: pxToRem(14),
    letterSpacing: pxToEm(0.5, 14),
    lineHeight: pxToEm(16, 14),
    height: pxToEm(16, 14),
    padding: '0 8px 0 0',
    fontFamily: theme.typography.fontFamily,
    opacity: 0,
  },
  inputRoot: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
  },
  inputInput: {
    fontSize: pxToRem(14),
    letterSpacing: pxToEm(0.5, 14),
    lineHeight: pxToEm(16, 14),
    height: pxToEm(16, 14),
    padding: 0,
    color: theme.palette.secondary[800],
    '&::placeholder': {
      opacity: '.34',
      color: theme.palette.secondary[400],
    },
  },
});

const ShareEmailFormField = ({
  input,
  inputRef,
  placeholder,
  onChange,
  onKeyDown,
  onFocus,
  onBlur,
  classes,
}) => (
  <div className={classes.textFieldContainer}>
    <div className={classes.textFieldValue}>
      {input.value || placeholder}
    </div>
    <Input
      placeholder={placeholder}
      {...input}
      disableUnderline
      classes={{
        root: classes.inputRoot,
        input: classes.inputInput,
      }}
      inputProps={{
        autoComplete: 'off',
      }}
      onKeyDown={onKeyDown}
      onChange={(event) => {
        input.onChange(event);
        onChange(event);
      }}
      onFocus={(event) => {
        input.onFocus(event);
        onFocus(event);
      }}
      onBlur={(event) => {
        input.onBlur(event);
        onBlur(event);
      }}
      inputRef={inputRef}
    />
  </div>
);

ShareEmailFormField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  inputRef: PropTypes.func,
  classes: PropTypes.shape({
    textFieldContainer: PropTypes.string.isRequired,
    textFieldValue: PropTypes.string.isRequired,
    inputRoot: PropTypes.string.isRequired,
    inputInput: PropTypes.string.isRequired,
  }).isRequired,
};

ShareEmailFormField.defaultProps = {
  placeholder: '',
  onChange: () => {},
  onKeyDown: () => {},
  onFocus: () => {},
  onBlur: () => {},
  inputRef: () => {},
};

export default withStyles(styles)(ShareEmailFormField);



// WEBPACK FOOTER //
// ./src/components/common/ShareDialog/ShareEmailFormField.js